<script lang="ts" setup>
  import PageLoading from '@/components/PageLoading.vue'
  import GuestLayout from '@/layouts/GuestLayout.vue'
</script>

<template>
  <GuestLayout>
    <PageLoading>Warte auf Sitzungdaten...</PageLoading>
  </GuestLayout>
</template>

<style scoped></style>
